export class InvoiceSummaryResponse
{
    public readonly number:any;
    public readonly periodStart:number;
    public readonly periodEnd:number;
    public readonly status:any;
    public readonly isOverdue:boolean;
    public readonly totalAmount:number;
    public readonly cloudAccessAmount:number;
    public readonly addonsAmount:number;

    constructor(json:any)
    {
        this.number = json['number'];
        this.periodStart = json['periodStart'];
        this.periodEnd = json['periodEnd'];
        this.status = json['status'];
        this.isOverdue = json['isOverdue'];
        this.totalAmount = json['totalAmount'];
        this.cloudAccessAmount = json['cloudAccessAmount'];
        this.addonsAmount = json['addonsAmount'];
    }
}
